import React, { FunctionComponent, ChangeEvent, useState, FormEventHandler } from 'react';
import Layout from '../../components/molecules/Layout';
import { ContactRecord } from '../../types/dato.types';
import { getContactPage } from 'src/lib/dato';
import { SinglePageHeader, SinglePageContent } from '../../components/molecules/SinglePage';

interface Props {
  contact: ContactRecord;
}

interface FormProp {
  name: string;
  email: string;
  message: string;
}

const Pagecontact: FunctionComponent<Props> = ({ contact }) => {
  const defaultFormObject = { name: '', email: '', message: '' };

  const [status, setStatus] = useState({
    submitted: false,
    submitting: false,
    info: { error: false, msg: null },
  });

  const [form, setForm] = useState<FormProp>(defaultFormObject);

  const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleBlur = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value.trim() });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setStatus((prevStatus) => ({ ...prevStatus, submitting: true }));
    const res = await fetch('/api/send', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(form),
    });
    const text = await res.text();
    handleResponse(res.status, text);
  };

  const handleResponse = (status, msg) => {
    if (status === 200) {
      setStatus({
        submitted: true,
        submitting: false,
        info: { error: false, msg: msg },
      });
      setForm(defaultFormObject);
    } else {
      setStatus({
        submitted: true,
        submitting: false,
        info: { error: true, msg: msg },
      });
    }
  };

  return (
    <Layout>
      <SinglePageHeader title={contact?.title} imageUrl={contact?.headerImage?.url} />
      <SinglePageContent>
        <div className="Contact">
          <p>
            T: <a href={`tel:${contact.phone}`}>{contact.phone}</a>
          </p>
          <p>
            E: <a href={`mailto:${contact.emailAddress}`}>{contact.emailAddress}</a>
          </p>
        </div>
        <div className="Contact__Form">
          <h3>Send a message</h3>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Name"
              value={form.name}
              name="name"
              onChange={handleChange}
              onBlur={handleBlur}
              required
            />
            <input
              type="email"
              placeholder="Email"
              value={form.email}
              name="email"
              onChange={handleChange}
              onBlur={handleBlur}
              required
            />
            <textarea
              rows={5}
              placeholder="Message"
              value={form.message}
              name="message"
              onChange={handleChange}
              onBlur={handleBlur}
              required
            />
            <input className="Contact__Form__SendButton" type="submit" value="Send" />
          </form>
          {!status.info.error && status.info.msg && (
            <div className="success">{status.info.msg}</div>
          )}
        </div>
      </SinglePageContent>
    </Layout>
  );
};

export async function getStaticProps() {
  const contact = await getContactPage();
  return {
    props: { contact },
  };
}

export default Pagecontact;
